import { render, staticRenderFns } from "./last-record-ref.vue?vue&type=template&id=191d17e5&scoped=true&"
import script from "./last-record-ref.vue?vue&type=script&lang=js&"
export * from "./last-record-ref.vue?vue&type=script&lang=js&"
import style0 from "./last-record-ref.vue?vue&type=style&index=0&id=191d17e5&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d17e5",
  null
  
)

export default component.exports